import { LocalStorage } from './../../../../../core/helper/localStorage';
import { Injectable } from '@angular/core';
import { AppService } from '../../../../../core/service/Base.Service';
import { DataTransferObject } from '../../../../../core/entities/DataTransferObject';
import { Institute } from './institute';
import { AnonymousSubject } from 'rxjs';

@Injectable()
export class InstituteService extends AppService<any> {

    constructor() {
        super('Legalentity');
    }


    async getInstitution() {

        const result = await this.get('');

        return result;
    }


    async postEntitiesAgainstClients(clients) {

        const data = <DataTransferObject<any>>{
            Data: clients,
        };

        const result = await this.post('EntitiesAgainstClients', data);
        return result;
    }

    async getentityList(entityid) {
        const data = this.get('EntityList', [entityid]);
        return data;
    }

    async getUserSchool() {
        const data = this.get('UserSchool');
        return data;
    }

    async getEntities() {
        const data = this.get('Entity');
        return data;
    }

    async getUserEntity() {
        const data = this.get('UserEntity');
        return data;
    }

    async getSelectedEntities(countryid, regionid, stateid, cityid, topicid) {
        const data = this.get('SelectedEntities', [countryid, regionid, stateid, cityid, topicid]);
        return data;
    }

    async getOrganizationStatus() {
        var entityid = Number(this.localStorage.get("selectedEntity"));
        const dto = await this.get('OrganizationStatus', [entityid]);
        return dto;
    }

    async getLoginUserEntities() {

        const dto = await this.get('EntityList');
        return dto;
    }

    async GetClientEntities(clientid) {
        const dto = await this.get('ClientEntities', [clientid]);
        return dto;
    }

    async getSelectedEntityInfo() {
        let entityid = this.localStorage.get('selectedEntity');
        const dto = await this.get('SelectedEntityInfo', [entityid]);
        return dto;
    }

    async GetUserEntityData(entities) {
        const data = <DataTransferObject<any>>{
            Data: entities,
        };

        const result = await this.post('UserEntityData', data);
        return result;
    }

    async getUserTypeWiseEntities(entitytypeid) {
        const data = this.get('UserTypeWiseEntities', [entitytypeid]);
        return data;
    }

    async partialentitysaving(Data){
         
        const _data = <DataTransferObject<any>>{
            Data: Data,
        };
         
        const result = await this.post('partialsaving',_data);
        return result;
    }
}





// WEBPACK FOOTER //
// ./src/app/shell/forms/organizational-setup/setup/institute/institute.service.ts